// npm packages
import { Tooltip, OverlayTrigger } from "react-bootstrap";

export const TooltipWrapper = ({ id, children, tooltip, position }) => {
  return (
    <OverlayTrigger
      overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
      placement={position}
      delayShow={300}
      delayHide={150}
    >
      {children}
    </OverlayTrigger>
  );
};
